import React, { useState, useEffect } from "react";

import { Helmet } from "react-helmet";

import ErrorBar from "../common/errorBar";
import LoaderFancy from "../common/loaderfancy";
import ResultsAnalyzeSentiments from "../../components/language/analysisSentiments";
import FeaturePaywallWrapper from "../../components/account/featurePaywallWrapper"

// analyzes filtered results for sentiment
const AudienceBrowseSentiment = ({
  currentUser,
  results,
  filterParams,
  fetching,
}) => {
  return (
    <div className="p-4 overflow-y-auto h-full">
      <Helmet><title>Audience | Browse | Sentiment</title></Helmet>
      <FeaturePaywallWrapper featureKey={"sentiment-report"} className={'max-w-full'} currentUser={currentUser}>
        {results && results.length ? (
          <ResultsAnalyzeSentiments
            currentUser={currentUser}
            results={results}
            limitOptions={[100, 200, 500]}
            filterParams={Object.assign(filterParams, {
              'sentiment_focus_keyword': filterParams.keyword, // ensures context is always in focus for this keyword
            })}
          />
        ) : fetching ? (
          <div className="p-4 overflow-y-auto h-full">
            <div className="h-48 relative">
              <LoaderFancy />
            </div>
          </div>
        ) : (
          <div className="p-6 bg-gray-800 rounded-lg border border-solid border-gray-700 text-white">
            <div className="">
              <h3 className="text-lg leading-6 font-medium">
                No results at this time...
              </h3>
            </div>
          </div>
        )}
      </FeaturePaywallWrapper>
    </div>
  );
}

export default AudienceBrowseSentiment;

